import { Modal, Button } from 'react-bootstrap';

const DeleteModal = (props) => {
  const { onHide, data, onDelete } = props;

  return (
    <Modal
      show={true}
      onHide={onHide}
      size="lg"
      aria-labelledby="delete-modal-title"
      centered
    >
      <Modal.Header closeButton>
        <h4 id="delete-modal-title">Delete {data.title}?</h4>
      </Modal.Header>
      <Modal.Footer>
        {/* <Button
          style={{
            backgroundColor: '#a64500',
            marginRight: '4px',
            border: 'none',
          }}
          onClick={() => {
            onDelete();
            onHide();
          }}
        >
          Delete
        </Button> */}
        <Button variant="secondary" onClick={() => onHide()}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default DeleteModal;
